{
  "errors": {
    "noActiveCompany": "No active company selected",
    "noCompanySelected": "Error: No company selected. Please contact your administrator.",
    "noResponseContent": "No response content received",
    "failedToGetResponse": "Failed to get response from AI",
    "accessDenied": "Access denied to company data",
    "sessionExpired": "Your session has expired. Please log in again.",
    "genericError": "Sorry, I encountered an error while processing your question. Please try again.",
    "noAuthToken": "No authentication token available. Please log in again.",
    "companyIdRequired": "Company ID is required to send questions",
    "authFailed": "Authentication failed. Please log in again.",
    "noCompanyDataAccess": "You don't have access to the data for this company",
    "httpError": "HTTP error! status: {{status}}",
    "companyIdRequiredForSecrets": "Company ID is required to store secrets",
    "integrationTypeRequired": "Integration type is required",
    "secretsArrayRequired": "Secrets array is required and must not be empty",
    "noSecretsPermission": "You don't have permission to manage secrets for this company",
    "invalidRequestData": "Invalid request data",
    "companyIdRequiredForMetadata": "Company ID is required to get secrets metadata",
    "noSecretsViewPermission": "You don't have permission to view secrets for this company",
    "invalidDateRange": "Invalid date format or range",
    "noCompanyAccess": "No company access found. Contact your admin or Revetall directly.",
    "failedToLoadCompanyInfo": "Failed to load company information",
    "sqlProcessingError": "Sorry, Revetall can not answer that question yet. If your question was composed of multiple questions, try to ask one at a time :) That might help!",
    "invalidLogin": "Please enter both email and password",
    "unexpectedLoginError": "An unexpected error occurred",
    "requiredField": "Employee Token (ETOKEN) is required"
  },
  "nav": {
    "askFox": "Ask the Revetall",
    "settings": "Settings",
    "logout": "Log Out"
  },
  "sidebar": {
    "overview": "Overview",
    "askFox": "Ask the Revetall",
    "dashboards": "Dashboards",
    "settings": "Settings",
    "projects": "Projects",
    "overviewDescription": "Gives the overview of how the company is doing",
    "askFoxDescription": "AI-driven financial analysis",
    "dashboardsDescription": "Your saved analytics",
    "settingsDescription": "Integrations and system settings",
    "projectsDescription": "Manage and track your projects"
  },
  "auth": {
    "login": "Log In",
    "loggingIn": "Logging in...",
    "email": "Email",
    "password": "Password",
    "emailPlaceholder": "Enter your email",
    "passwordPlaceholder": "Enter your password",
    "tagline": "Built for project businesses that have a lot to do",
    "contactMessage": "Want to try Revetall? Contact us at"
  },
  "chat": {
    "welcomeMessageLead": "Hey, I'm Revetall!",
    "welcomeMessageBody": "I know about your projects, your employees, your financials and more — try asking a question and I'll look into the relevant data and answer you. If you see something that doesn't make sense, please let us know — we're always improving :)",
    "welcomeQuestionsIntro": "Here are some questions you can try:",
    "exampleQuestions": {
      "1": "How are we doing so far this year?",
      "2": "Which projects have been most profitable?",
      "3": "Who has the highest billable rate?",
      "4": "How long will our buffer last if times get tougher?"
    },
    "thinking": "Revetall is thinking...",
    "send": "Send",
    "sending": "Sending...",
    "placeholder": "Ask me a question:)",
    "followUpIntro": "Would you like to explore any of this further?",
    "customEllipsis": "Custom…",
    "submit": "Send",
    "cancel": "Cancel",
    "you": "You",
    "revetall": "Revetall",
    "share": "Share",
    "shareTitle": "Share conversation",
    "shareSave": "Save",
    "shareSaving": "Saving...",
    "shareCopy": "Copy link",
    "shareCopied": "Copied",
    "shareNoUsers": "No other users in this company.",
    "shareLoadError": "Could not load who this conversation can be shared with.",
    "shareSaveError": "Could not update sharing.",
    "shareCopyError": "Could not copy the link.",
    "shareNotFound": "This conversation cannot be shared.",
    "shareOptionLink": "Link",
    "shareOptionEmail": "Email",
    "shareModeLabel": "Share method",
    "shareEmailDefaultMessage": "Hi, I found something interesting in Revetall — take a look and we can talk afterwards",
    "shareEmailSend": "Send email",
    "shareEmailSending": "Sending...",
    "shareEmailSent": "Email sent.",
    "shareEmailPartialFail": "Email could not be sent to: {{emails}}",
    "shareEmailSendError": "Could not send the email."
  },
  "sessions": {
    "newConversation": "New Conversation",
    "deleteConversation": "Delete Conversation",
    "allConversations": "All conversations"
  },
  "app": {
    "loading": "Loading...",
    "error": "Error",
    "updateAvailable": "A new version of Revetall is available.",
    "refreshApp": "Refresh"
  },
  "cashBalance": {
    "notAvailable": "Not available"
  },
  "settings": {
    "title": "Settings",
    "description": "Manage integrations and system configuration",
    "tripletex": {
      "title": "Tripletex Integration",
      "description": "Configure your Tripletex API keys",
      "currentConfig": "Current configuration",
      "noKeys": "No Tripletex keys configured yet",
      "useForm": "Use the form below to set up the integration",
      "employeeToken": "Employee Token (ETOKEN)",
      "tokenPlaceholder": "Paste your Tripletex Employee Token",
      "tokenHelp": "Your Tripletex Employee Token for API access",
      "updateKeys": "Update keys",
      "saveKeys": "Save keys",
      "saving": "Saving...",
      "adminNotice": "Only company administrators can update integration settings",
      "createdAndUpdated": "Created {{created}} key(s) and updated {{updated}} key(s)",
      "keysCreated": "Created {{count}} Tripletex key(s)",
      "keysUpdated": "Updated {{count}} Tripletex key(s)",
      "keysProcessed": "Tripletex keys processed",
      "saveError": "Could not save keys. Please try again.",
      "active": "Active",
      "configured": "Configured:"
    }
  },
  "messages": {
    "timePeriod": "Period:",
    "sources": "Sources:",
    "from": "from",
    "seeVisualization": "See visualization"
  },
  "charts": {
    "visualizations": "Visualizations",
    "noDataMessage": "Here we will show you visually what you asked about in the chat",
    "period": "Period:",
    "granularity": "Granularity:",
    "sources": "Sources:",
    "to": "to",
    "chartTypes": {
      "line": "Line",
      "bar": "Bar",
      "pie": "Pie",
      "area": "Area",
      "table": "Table",
      "scatter": "Scatter"
    },
    "graphFallbackLabel": "Graph",
    "andMore": "& {{count}} more",
    "noData": "No data available for chart",
    "value": "Value",
    "dataType": "Data type:",
    "notAvailable": "Not available",
    "chartInfo": {
      "metadata": "Metadata"
    }
  },
  "dashboards": {
    "title": "Dashboards",
    "dashboardsDescription": "Your saved analytics",
    "noDashboards": "No dashboards yet",
    "createFirst": "Create your first dashboard to get started",
    "emptyDashboard": "This dashboard is empty",
    "emptyMessage": "Find what you want to add to your dashboard by using the chat.",
    "dashboardFull": "Dashboard is full (maximum {{max}} widgets)",
    "addToDashboard": "Add to Dashboard",
    "widgetName": "Widget Name",
    "widgetNamePlaceholder": "Enter a name for this widget",
    "cancel": "Cancel",
    "add": "Add",
    "addedSuccessfully": "Added successfully",
    "saving": "Saving...",
    "selectDashboard": "Select Dashboard",
    "sources": "Sources:",
    "refreshWidget": "Refresh data",
    "refreshing": "Refreshing...",
    "factTable": "Fact Table:",
    "dimensionalTables": "Dimensional Tables:",
    "loading": "Loading...",
    "error": "Error loading dashboard",
    "widgetError": "Failed to load widget data",
    "retry": "Retry",
    "deleteWidget": "Delete Widget",
    "deleteWidgetConfirm": "Are you sure you want to delete \"{{name}}\"?",
    "deleteWidgetWarning": "This action cannot be undone.",
    "delete": "Delete",
    "deleting": "Deleting..."
  },
  "common": {
    "close": "Close",
    "cancel": "Cancel"
  },
  "overview": {
    "title": "Estimated Cash Holdings",
    "loading": "Loading cash holdings data...",
    "error": "Failed to load cash holdings data",
    "noData": "No cash holdings data available",
    "availableCash": "Available Cash",
    "events": "Events",
    "viewRange": "View",
    "days": "days",
    "includeNonInvoicedWork": "Include not invoiced hourly work",
    "includeNonInvoicedWorkExplanation": "Adds estimated cash inflows from work that has not been invoiced yet",
    "includeOverdueInvoices": "Include outstanding payments",
    "includeOverdueInvoicesExplanation": "Adds overdue amounts customers still owe as cash in tomorrow",
    "guideLegend": "Dashed line is current cashflow. Filled line includes the selected options.",
    "modeLabel": "Chart mode",
    "modeCashflow": "Your Account",
    "modeReceivables": "Outstanding",
    "modeContractBacklog": "Contract backlog",
    "tooltipCashflowScope": "Future cashflow",
    "tooltipBacklogScope": "Historic contract backlog",
    "remainingBacklog": "Remaining backlog",
    "backlogLoading": "Loading contract backlog...",
    "backlogError": "Failed to load contract backlog",
    "backlogNoData": "No contract backlog data available",
    "months_3": "3 months",
    "months_6": "6 months",
    "months_12": "12 months",
    "receivablesAge_91": "3 months",
    "receivablesAge_182": "6 months",
    "receivablesAge_365": "1 year",
    "receivablesAge_730": "2 years",
    "receivablesLoading": "Loading outstanding payments...",
    "receivablesError": "Failed to load outstanding payments",
    "receivablesNoData": "No outstanding payments",
    "receivablesColumns": {
      "customer": "Customer",
      "overdue": "Outstanding amount"
    },
    "receivablesHover": {
      "invoiceNumber": "Invoice",
      "daysOverdue": "Days overdue",
      "billed": "Billed",
      "credited": "Credited",
      "paid": "Paid",
      "remaining": "Outstanding"
    },
    "eventNames": {
      "delta_vat": "VAT Payment",
      "employer_contribution": "Employer Contribution",
      "inbound_invoice": "Invoices Due",
      "outbound_invoice": "Customer Invoices Due",
      "projected_outbound_invoice": "Not invoiced hourly work",
      "overdue_outbound_invoice": "Outstanding payments",
      "holiday_pay": "Holiday Pay",
      "payslip": "Salary Payments"
    },
    "backlogEventNames": {
      "contract_added": "New contract",
      "contract_adjusted": "Contract adjusted",
      "outbound_invoice": "Project invoiced",
      "project_closed": "Project closed"
    }
  },
  "kpis": {
    "costPerHour": "Cost per Hour",
    "costPerHourExplanation": "Total cost per hour worked, including all expenses",
    "personnelCostPerHour": "Personnel Cost per Hour",
    "personnelCostPerHourExplanation": "Personnel cost per one hour worked, including all expenses under personnel expenses",
    "breakEvenHourlyRate": "Break-Even Hourly Rate",
    "breakEvenHourlyRateExplanation": "Break-even hourly rate is the lowest hourly rate you must charge to cover all costs, without earning or losing money, given the current billable rate",
    "billableRate": "Billable Rate",
    "billableRateExplanation": "The percentage of hours that are billed to customers",
    "loading": "Loading KPIs...",
    "error": "Failed to load KPIs",
    "noData": "No KPI data available"
  },
  "projects": {
    "title": "Projects",
    "active": "Active",
    "inactive": "Inactive",
    "no_activity": "Not started",
    "closed": "Closed",
    "internal": "Internal",
    "loading": "Loading projects...",
    "error": "Failed to load projects",
    "noProjects": "No projects found",
    "backToList": "Back to projects",
    "saving": "Saving...",
    "saveError": "Failed to save changes",
    "columns": {
      "sourceProjectNumber": "Nr. Tripletex",
      "name": "Name",
      "profitability": "Profitability",
      "customer": "Customer",
      "hours": "Hours spent",
      "hoursSpentInvoiced": "Hours billed",
      "rate": "Actual hourly rate",
      "totalRevenue": "Total revenue",
      "totalCosts": "Total costs",
      "cost": "Cost",
      "profit": "Profit",
      "contractValue": "Contract value",
      "remainingContractValue": "Remaining contract value",
      "remainingContract": "Remaining contract",
      "credited": "Credited",
      "overInvoiced": "Over-invoiced",
      "billableRate": "Billable rate",
      "otherCosts": "Other costs",
      "status": "Status"
    },
    "tabs": {
      "fullOverview": "Full Overview"
    },
    "details": {
      "startDate": "Start Date",
      "endDate": "End Date",
      "personnelCost": "Salaries",
      "contributionMargin": "Contribution Margin",
      "invoicedExplanation": "The total amount you have billed the customer for this project, before VAT is added.",
      "costExplanation": "Everything this project has cost you — wages, materials, subcontractors, and other expenses.",
      "profitExplanation": "What you actually made on this project after paying all the bills. A positive number means the project was profitable.",
      "hoursExplanation": "All the hours your team has logged on this project — both billed and unbilled.",
      "rateExplanation": "How much revenue you earned for each hour worked on this project.",
      "personnelCostExplanation": "What you have paid in personnel costs for people working on this project.",
      "contributionMarginExplanation": "For every 100 kr you bill, how many kr are left after paying wages. For example, 40% means 40 kr remains from every 100 kr billed.",
      "remainingContractValueExplanation": "How much of the agreed contract price is still left to invoice. Never below zero — any amount billed above the contract is shown under Over-invoiced.",
      "creditedExplanation": "Lifetime total of credit notes issued on this project, before VAT. Shown as a positive amount.",
      "overInvoicedExplanation": "How much net invoiced revenue exceeds the contract value. Empty when the project is not over-invoiced.",
      "remainingContractPercentageExplanation": "What percentage of the total contract is still left to invoice. 50% means you have billed half the contract so far.",
      "contractValueSpentPercentageExplanation": "What percentage of the total contract value has been invoiced so far. 50% means you have billed half the contract.",
      "billableRateExplanation": "What share of your team's hours you have actually charged to the customer. 80% means 8 out of every 10 hours worked are billed.",
      "materialCosts": "Materials",
      "materialCostsExplanation": "What you spent on materials for this project — raw materials and goods used in the work.",
      "subcontractorCosts": "Subcontractors",
      "subcontractorCostsExplanation": "What you paid to subcontractors or hired-in personell working on this project.",
      "logisticsCosts": "Logistics",
      "logisticsCostsExplanation": "Transport and freight costs related to this project.",
      "otherCostsExplanation": "Any remaining costs that don't fall into wages, materials, subcontractors, or logistics.",
      "hoursSpentInvoicedExplanation": "How many of your total hours have been billed to the customer. Compare this with total hours to spot unbilled work.",
      "warningTitle": {
        "overdue": "Overdue invoices",
        "profitability": "Profitability warning",
        "uninvoiced": "Accrued work warning"
      },
      "overdueInvoiceWarning": "Invoice number {{invoiceNumber}} is {{daysOverdue}} days overdue, outstanding amount is {{amount}} kr.",
      "overdueInvoicesSummary": "{{count}} invoices are overdue for this project, the most overdue is {{daysOverdue}} days, the total outstanding amount is {{amount}} kr.",
      "performanceOnTrack": "The project is on track",
      "performanceFollowUp": "You should follow up this project",
      "performanceActionRequired": "This project requires action now",
      "profitabilityBelowBudget": "Contribution margin is {{margin}}, which is below the budget of {{benchmark}}.",
      "profitabilityBelowCompanyAverage": "Contribution margin is {{margin}}, which is below the company average of {{benchmark}}.",
      "profitabilityAtOrBelowZero": "Contribution margin is {{margin}}, if this continues you will loose money on this project.",
      "uninvoicedWorkWarning": "{{days}} days has past since we expected you to send an invoice for this project. The last invoice was sent {{lastInvoiceDate}} and we expected you to send the next invoice around {{expectedDate}}.",
      "uninvoicedWorkHoursAndCosts": "You haven't invoiced this project in {{days}} days, and {{hours}} hours of work and {{amount}} kr of costs have been done after the last invoice.",
      "uninvoicedWorkHours": "You haven't invoiced this project in {{days}} days, and {{hours}} hours of work have been done after the last invoice.",
      "uninvoicedWorkCosts": "You haven't invoiced this project in {{days}} days, and {{amount}} kr of costs have been done after the last invoice.",
      "uninvoicedWorkDays": "You haven't invoiced this project in {{days}} days.",
 
      "sectionHours": "Hours",
      "sectionHoursDistribution": "Hours Distribution",
      "sectionHoursEfficiency": "Hours Efficiency",
      "sectionContract": "Contract",
      "sectionRevenue": "Revenue",
      "sectionCosts": "Costs",
      "sectionResult": "Result",
      "sectionEfficiency": "Efficiency",
      "sectionProfitability": "Profitability",
      "sectionKeySummary": "Key Summary",
      "sectionProjectStructure": "Project structure",
      "familyAll": "All",
      "margin": "Margin",
      "contractReservePercentage": "Contract reserve in %",
      "contractValueSpentPercentage": "Contract spent in %",
      "totalRevenueExVat": "Total revenue (ex. VAT)",
      "revenueHours": "Hours",
      "revenueHoursExplanation": "Revenue from time or hourly billing on this project, before VAT.",
      "revenueFixedPrice": "Fixed price",
      "revenueFixedPriceExplanation": "Revenue from fixed-price deliverables on this project, before VAT.",
      "revenueMaterial": "Materials",
      "revenueMaterialExplanation": "Revenue from materials or product sales on this project, before VAT.",
      "revenueOther": "Other",
      "revenueOtherExplanation": "Other billed revenue that does not fall into hours, fixed price, or materials, before VAT.",
      "costPerHour": "Cost per hour",
      "costPerHourExplanation": "What this project costs you for every hour worked. If this is higher than your hourly rate, you are losing money on each hour.",
      "personnelCostPerHour": "Personnel cost per hour",
      "personnelCostPerHourExplanation": "The wage cost per hour on this project. Useful to check if your people are matched to the right billing rate.",
      "contributionPerHour": "Profit per hour",
      "contributionPerHourExplanation": "How much profit each hour worked generates. A higher number means each hour is more valuable to the business.",
      "contributionPerCost": "Return on costs",
      "contributionPerCostExplanation": "For every 1 kr you spend on this project, how much profit you make. Above 0 means you are earning back your costs and making extra.",
      "nonInvoicedWork": "Not invoiced hourly work",
      "nonInvoicedWorkExplanation": "Estimated value of chargeable work that has not been invoiced yet. Includes work with no invoice and work linked to an invoice that has not been issued yet.",
      "nonInvoicedBillableHours": "Not invoiced billable hours",
      "nonInvoicedBillableHoursExplanation": "Chargeable hours that have not been invoiced yet. Includes hours with no invoice and hours linked to an invoice that has not been issued yet.",
      "hoursUnknownActivity": "Unknown activity",
      "contractBarSpent": "Invoiced",
      "includeNonInvoicedWorkExplanation": "Includes not-yet-invoiced hourly work in revenue, profit, margin, and hour rate.",
      "includeNonInvoicedWorkHint": "Includes hourly work done but not yet invoiced.",
      "contractBarRemaining": "Remaining",
      "sectionPlannedVsActual": "Planned vs Actual",
      "plannedBudgetPrompt": "Want to see this project against the plan? Send an Excel sheet, offer letter, or similar to",
      "planned": "Planned",
      "actual": "Actual",
      "percentUsed": "% Used",
      "hourRate": "Hour rate"
    }
  }
}

